import { render, staticRenderFns } from "./RemoveVehicle.vue?vue&type=template&id=23481a62&scoped=true"
import script from "./RemoveVehicle.vue?vue&type=script&lang=js"
export * from "./RemoveVehicle.vue?vue&type=script&lang=js"
import style0 from "./RemoveVehicle.vue?vue&type=style&index=0&id=23481a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23481a62",
  null
  
)

export default component.exports